import * as React from 'react';
import {FormattedMessage, FormattedDate} from '@meiko/react-intl';
import {fullAddress} from 'utils/buildings';
import {getBuildingMapAddress} from 'utils/lists';
import Link from 'components/generic/Link';
import {User2, MapPin} from 'lucide-react';
import {Tooltip} from 'components/ui/Tooltip';
import {twMerge} from 'tailwind-merge';

export default function BuildingInformation({building = null, listItem, className}) {
	const mapAddr = getBuildingMapAddress(building);

	const hasClient =
		Array.isArray(building?.clients?.data) && building?.clients?.data?.length > 0;

	if (!building) {
		return null;
	}

	return (
		<div className={twMerge('flex flex-col items-start', className)}>
			<div className="flex items-center text-sm gap-x-2">
				{fullAddress(building)}{' '}
				{hasClient && <User2 size={14} className="text-gray-400" />}{' '}
				{mapAddr && (
					<Tooltip
						size="sm"
						trigger={
							<Link href={mapAddr} rel="noopener noreferrer" target="_blank">
								<MapPin
									size={14}
									className="cursor-pointer text-gray-400 hover:text-black"
								/>
							</Link>
						}
					>
						<span className="text-xs">
							<FormattedMessage id="View on Google Maps" />
						</span>
					</Tooltip>
				)}
			</div>
			<div className="flex items-center gap-x-6">
				<div className="text-xs text-gray-500">
					<FormattedMessage id="Manufacturing year" />{' '}
					{building.manufacturingYear ?? <FormattedMessage id="Not known" />}
				</div>
			</div>
			<div className="text-xs text-gray-500">
				<FormattedMessage id="Added" /> <FormattedDate value={listItem.createdAt} />
			</div>
		</div>
	);
}
